import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-divider");
import { style } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
export const base = style({
  border: 'none',
  borderTop: `${tokens.border.thickness.normal} solid ${tokens.color.structure.divider}`,
  margin: `${tokens.space[150]} 0`
}, 'divider_base');
__vanilla_filescope__.endFileScope();
